import { Print, RotateRight } from "@mui/icons-material"
import { Button } from "@mui/material"
import './Controls.scss'

type Props = {
  onRotate?: () => void
  onPrint?: () => void
}

export function Controls(props: Props) {
  const rotate = () => {
    if(props.onRotate) props.onRotate()
  }

  const print = () => {
    if(props.onPrint) props.onPrint()
  }

  return (
    <aside className="controls">
      <Button name="onRotate" variant="contained" onClick={() => print()} title="Imprimir">
        <Print />
      </Button>

      <Button name="onPrint" variant="contained" onClick={() => rotate()} title="Girar">
        <RotateRight />
      </Button>
    </aside>
  )
}